import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

interface ChannelFiltersProps {
    onFilterChange: (filters: {
        destination?: string;
        shipping_method?: string;
        is_active?: string;
    }) => void;
}

export const ChannelFilters: React.FC<ChannelFiltersProps> = ({ onFilterChange }) => {
    const handleChange = (key: string, value: string | undefined) => {
        onFilterChange({ [key]: value || '' });
    };

    return (
        <div style={{ marginBottom: 16, display: 'flex', gap: 16 }}>
            <Select
                placeholder="筛选目的地"
                style={{ width: 200 }}
                allowClear
                onChange={(value) => handleChange('destination', value)}
            >
                <Option value="美国">美国</Option>
                <Option value="欧洲">欧洲</Option>
                <Option value="日本">日本</Option>
                <Option value="英国">英国</Option>
            </Select>

            <Select
                placeholder="筛选运输方式"
                style={{ width: 150 }}
                allowClear
                onChange={(value) => handleChange('shipping_method', value)}
            >
                <Option value="sea">海运</Option>
                <Option value="air">空运</Option>
                <Option value="express">快递</Option>
                <Option value="rail">铁路</Option>
                <Option value="truck">卡车</Option>
            </Select>

            <Select
                placeholder="筛选状态"
                style={{ width: 120 }}
                allowClear
                onChange={(value) => handleChange('is_active', value)}
            >
                <Option value="true">启用</Option>
                <Option value="false">停用</Option>
            </Select>
        </div>
    );
};
